module.exports = __webpack_public_path__ + "static/media/paso3compra.f54c5a50.svg";